{
  "sourcePatchVersion": "9",
  "defaultLocale": "ko",
  "locales": [
    {
      "code": "ko",
      "englishName": "Korean",
      "nativeName": "한국어",
      "direction": "ltr",
      "font": "common_font_01.ttf",
      "tier": 1,
      "order": 1,
      "termCount": 0,
      "coverage": 1
    },
    {
      "code": "en",
      "englishName": "English",
      "nativeName": "English",
      "direction": "ltr",
      "font": "common_font_01.ttf",
      "tier": 1,
      "order": 2,
      "termCount": 869,
      "coverage": 0.7272
    },
    {
      "code": "zh-CN",
      "englishName": "Chinese (Simplified)",
      "nativeName": "中文(简体)",
      "direction": "ltr",
      "font": "NotoSansSC-Bold.ttf",
      "tier": 1,
      "order": 3,
      "termCount": 869,
      "coverage": 0.7272
    },
    {
      "code": "zh-TW",
      "englishName": "Chinese (Traditional)",
      "nativeName": "中文(繁體)",
      "direction": "ltr",
      "font": "NotoSansTC-Bold.ttf",
      "tier": 1,
      "order": 4,
      "termCount": 869,
      "coverage": 0.7272
    },
    {
      "code": "ja",
      "englishName": "Japanese",
      "nativeName": "日本語",
      "direction": "ltr",
      "font": "Mochiy_Pop_One.ttf",
      "tier": 1,
      "order": 5,
      "termCount": 869,
      "coverage": 0.7272
    },
    {
      "code": "es",
      "englishName": "Spanish",
      "nativeName": "español",
      "direction": "ltr",
      "font": "Fredoka-Bold.ttf",
      "tier": 1,
      "order": 6,
      "termCount": 869,
      "coverage": 0.7272
    },
    {
      "code": "de",
      "englishName": "German",
      "nativeName": "Deutsch",
      "direction": "ltr",
      "font": "Fredoka-Bold.ttf",
      "tier": 1,
      "order": 7,
      "termCount": 869,
      "coverage": 0.7272
    },
    {
      "code": "fr",
      "englishName": "French",
      "nativeName": "Français",
      "direction": "ltr",
      "font": "Fredoka-Bold.ttf",
      "tier": 1,
      "order": 8,
      "termCount": 869,
      "coverage": 0.7272
    },
    {
      "code": "pt",
      "englishName": "Portuguese",
      "nativeName": "Português",
      "direction": "ltr",
      "font": "Fredoka-Bold.ttf",
      "tier": 2,
      "order": 1,
      "termCount": 869,
      "coverage": 0.7272
    },
    {
      "code": "ru",
      "englishName": "Russian",
      "nativeName": "Русский",
      "direction": "ltr",
      "font": "Nunito-Bold.ttf",
      "tier": 2,
      "order": 2,
      "termCount": 869,
      "coverage": 0.7272
    },
    {
      "code": "ar",
      "englishName": "Arabic",
      "nativeName": "عربي",
      "direction": "rtl",
      "font": "noto_sans_arabic_bold.ttf",
      "tier": 2,
      "order": 3,
      "termCount": 869,
      "coverage": 0.7272
    },
    {
      "code": "it",
      "englishName": "Italian",
      "nativeName": "Italiano",
      "direction": "ltr",
      "font": "Fredoka-Bold.ttf",
      "tier": 2,
      "order": 4,
      "termCount": 869,
      "coverage": 0.7272
    },
    {
      "code": "nl",
      "englishName": "Dutch",
      "nativeName": "Nederlands",
      "direction": "ltr",
      "font": "Fredoka-Bold.ttf",
      "tier": 2,
      "order": 5,
      "termCount": 869,
      "coverage": 0.7272
    },
    {
      "code": "tr",
      "englishName": "Turkish",
      "nativeName": "Türkçe",
      "direction": "ltr",
      "font": "Fredoka-Bold.ttf",
      "tier": 2,
      "order": 6,
      "termCount": 869,
      "coverage": 0.7272
    },
    {
      "code": "id",
      "englishName": "Indonesian",
      "nativeName": "bahasa Indonesia",
      "direction": "ltr",
      "font": "common_font_01.ttf",
      "tier": 2,
      "order": 7,
      "termCount": 869,
      "coverage": 0.7272
    },
    {
      "code": "th",
      "englishName": "Thai",
      "nativeName": "ภาษาไทย",
      "direction": "ltr",
      "font": "Kanit-Bold.ttf",
      "tier": 2,
      "order": 8,
      "termCount": 869,
      "coverage": 0.7272
    },
    {
      "code": "vi",
      "englishName": "Vietnamese",
      "nativeName": "Tiếng Việt",
      "direction": "ltr",
      "font": "Montserrat-Black.ttf",
      "tier": 2,
      "order": 9,
      "termCount": 869,
      "coverage": 0.7272
    },
    {
      "code": "pl",
      "englishName": "Polish",
      "nativeName": "Polski",
      "direction": "ltr",
      "font": "Fredoka-Bold.ttf",
      "tier": 2,
      "order": 10,
      "termCount": 869,
      "coverage": 0.7272
    },
    {
      "code": "hi",
      "englishName": "Hindi",
      "nativeName": "हिंदी",
      "direction": "ltr",
      "font": "Poppins-Black.ttf",
      "tier": 2,
      "order": 11,
      "termCount": 869,
      "coverage": 0.7272
    },
    {
      "code": "sv",
      "englishName": "Swedish",
      "nativeName": "svenska",
      "direction": "ltr",
      "font": "Fredoka-Bold.ttf",
      "tier": 3,
      "order": 1,
      "termCount": 869,
      "coverage": 0.7272
    },
    {
      "code": "no",
      "englishName": "Norwegian",
      "nativeName": "norsk",
      "direction": "ltr",
      "font": "Fredoka-Bold.ttf",
      "tier": 3,
      "order": 2,
      "termCount": 869,
      "coverage": 0.7272
    },
    {
      "code": "da",
      "englishName": "Danish",
      "nativeName": "dansk",
      "direction": "ltr",
      "font": "Fredoka-Bold.ttf",
      "tier": 3,
      "order": 3,
      "termCount": 869,
      "coverage": 0.7272
    },
    {
      "code": "fi",
      "englishName": "Finnish",
      "nativeName": "Suomalainen",
      "direction": "ltr",
      "font": "Fredoka-Bold.ttf",
      "tier": 3,
      "order": 4,
      "termCount": 869,
      "coverage": 0.7272
    },
    {
      "code": "cs",
      "englishName": "Czech",
      "nativeName": "čeština",
      "direction": "ltr",
      "font": "Fredoka-Bold.ttf",
      "tier": 3,
      "order": 5,
      "termCount": 869,
      "coverage": 0.7272
    },
    {
      "code": "ro",
      "englishName": "Romanian",
      "nativeName": "Română",
      "direction": "ltr",
      "font": "Fredoka-Bold.ttf",
      "tier": 3,
      "order": 6,
      "termCount": 869,
      "coverage": 0.7272
    },
    {
      "code": "hu",
      "englishName": "Hungarian",
      "nativeName": "Magyar",
      "direction": "ltr",
      "font": "Fredoka-Bold.ttf",
      "tier": 3,
      "order": 7,
      "termCount": 869,
      "coverage": 0.7272
    },
    {
      "code": "el",
      "englishName": "Greek",
      "nativeName": "Ελληνικά",
      "direction": "ltr",
      "font": "GFSNeohellenic-Bold.ttf",
      "tier": 3,
      "order": 8,
      "termCount": 869,
      "coverage": 0.7272
    },
    {
      "code": "uk",
      "englishName": "Ukrainian",
      "nativeName": "українська",
      "direction": "ltr",
      "font": "Fredoka-Bold.ttf",
      "tier": 3,
      "order": 9,
      "termCount": 869,
      "coverage": 0.7272
    },
    {
      "code": "bg",
      "englishName": "Bulgarian",
      "nativeName": "български",
      "direction": "ltr",
      "font": "Fredoka-Bold.ttf",
      "tier": 3,
      "order": 10,
      "termCount": 869,
      "coverage": 0.7272
    },
    {
      "code": "sk",
      "englishName": "Slovak",
      "nativeName": "slovenský",
      "direction": "ltr",
      "font": "Fredoka-Bold.ttf",
      "tier": 3,
      "order": 11,
      "termCount": 869,
      "coverage": 0.7272
    },
    {
      "code": "hr",
      "englishName": "Croatian",
      "nativeName": "Hrvatski",
      "direction": "ltr",
      "font": "Fredoka-Bold.ttf",
      "tier": 3,
      "order": 12,
      "termCount": 869,
      "coverage": 0.7272
    },
    {
      "code": "sr",
      "englishName": "Serbian",
      "nativeName": "Српски",
      "direction": "ltr",
      "font": "Fredoka-Bold.ttf",
      "tier": 3,
      "order": 13,
      "termCount": 869,
      "coverage": 0.7272
    },
    {
      "code": "ms",
      "englishName": "Malay",
      "nativeName": "Melayu",
      "direction": "ltr",
      "font": "common_font_01.ttf",
      "tier": 3,
      "order": 14,
      "termCount": 869,
      "coverage": 0.7272
    },
    {
      "code": "fil",
      "englishName": "Filipino",
      "nativeName": "Filipino",
      "direction": "ltr",
      "font": "common_font_01.ttf",
      "tier": 3,
      "order": 15,
      "termCount": 869,
      "coverage": 0.7272
    },
    {
      "code": "he",
      "englishName": "Hebrew",
      "nativeName": "עִברִית",
      "direction": "rtl",
      "font": "NotoSansHebrew-Bold.ttf",
      "tier": 3,
      "order": 16,
      "termCount": 869,
      "coverage": 0.7272
    },
    {
      "code": "fa",
      "englishName": "Persian",
      "nativeName": "فارسی",
      "direction": "rtl",
      "font": "noto_sans_arabic_bold.ttf",
      "tier": 3,
      "order": 17,
      "termCount": 869,
      "coverage": 0.7272
    },
    {
      "code": "ur",
      "englishName": "Urdu",
      "nativeName": "اردو",
      "direction": "rtl",
      "font": "noto_sans_arabic_bold.ttf",
      "tier": 3,
      "order": 18,
      "termCount": 869,
      "coverage": 0.7272
    },
    {
      "code": "am",
      "englishName": "Amharic",
      "nativeName": "አማርኛ",
      "direction": "ltr",
      "font": "NotoSansEthiopic-Bold.ttf",
      "tier": 4,
      "order": 1,
      "termCount": 869,
      "coverage": 0.7272
    },
    {
      "code": "ka",
      "englishName": "Georgian",
      "nativeName": "ქართული",
      "direction": "ltr",
      "font": "NotoSansGeorgian-Bold.ttf",
      "tier": 4,
      "order": 2,
      "termCount": 869,
      "coverage": 0.7272
    },
    {
      "code": "hy",
      "englishName": "Armenian",
      "nativeName": "հայերեն",
      "direction": "ltr",
      "font": "NotoSansArmenian-Bold.ttf",
      "tier": 4,
      "order": 3,
      "termCount": 869,
      "coverage": 0.7272
    },
    {
      "code": "jv",
      "englishName": "Javanese",
      "nativeName": "basa jawa",
      "direction": "ltr",
      "font": "Fredoka-Bold.ttf",
      "tier": 4,
      "order": 4,
      "termCount": 869,
      "coverage": 0.7272
    },
    {
      "code": "my",
      "englishName": "Myanmar (Burmese)",
      "nativeName": "မြန်မာ (ဗမာ)၊",
      "direction": "ltr",
      "font": "NotoSansMyanmar-Bold.ttf",
      "tier": 4,
      "order": 5,
      "termCount": 869,
      "coverage": 0.7272
    },
    {
      "code": "uz",
      "englishName": "Uzbek",
      "nativeName": "o'zbek",
      "direction": "ltr",
      "font": "Fredoka-Bold.ttf",
      "tier": 4,
      "order": 6,
      "termCount": 869,
      "coverage": 0.7272
    },
    {
      "code": "sw",
      "englishName": "Swahili",
      "nativeName": "kiswahili",
      "direction": "ltr",
      "font": "Fredoka-Bold.ttf",
      "tier": 4,
      "order": 7,
      "termCount": 869,
      "coverage": 0.7272
    },
    {
      "code": "kk",
      "englishName": "Kazakh",
      "nativeName": "қазақ",
      "direction": "ltr",
      "font": "Fredoka-Bold.ttf",
      "tier": 4,
      "order": 8,
      "termCount": 869,
      "coverage": 0.7272
    },
    {
      "code": "ha",
      "englishName": "Hausa",
      "nativeName": "Hausa",
      "direction": "ltr",
      "font": "Fredoka-Bold.ttf",
      "tier": 4,
      "order": 9,
      "termCount": 869,
      "coverage": 0.7272
    },
    {
      "code": "az",
      "englishName": "Azerbaijani",
      "nativeName": "Azərbaycan",
      "direction": "ltr",
      "font": "Fredoka-Bold.ttf",
      "tier": 4,
      "order": 10,
      "termCount": 869,
      "coverage": 0.7272
    },
    {
      "code": "af",
      "englishName": "Afrikaans",
      "nativeName": "Afrikaans",
      "direction": "ltr",
      "font": "Fredoka-Bold.ttf",
      "tier": 4,
      "order": 11,
      "termCount": 869,
      "coverage": 0.7272
    },
    {
      "code": "is",
      "englishName": "Icelandic",
      "nativeName": "íslenskur",
      "direction": "ltr",
      "font": "Fredoka-Bold.ttf",
      "tier": 4,
      "order": 12,
      "termCount": 869,
      "coverage": 0.7272
    },
    {
      "code": "et",
      "englishName": "Estonian",
      "nativeName": "eesti keel",
      "direction": "ltr",
      "font": "Fredoka-Bold.ttf",
      "tier": 4,
      "order": 13,
      "termCount": 869,
      "coverage": 0.7272
    },
    {
      "code": "lt",
      "englishName": "Lithuanian",
      "nativeName": "lietuvių",
      "direction": "ltr",
      "font": "Fredoka-Bold.ttf",
      "tier": 4,
      "order": 14,
      "termCount": 869,
      "coverage": 0.7272
    },
    {
      "code": "ig",
      "englishName": "Igbo",
      "nativeName": "Igbo",
      "direction": "ltr",
      "font": "Fredoka-Bold.ttf",
      "tier": 4,
      "order": 15,
      "termCount": 869,
      "coverage": 0.7272
    },
    {
      "code": "zu",
      "englishName": "Zulu",
      "nativeName": "Zulu",
      "direction": "ltr",
      "font": "Fredoka-Bold.ttf",
      "tier": 4,
      "order": 16,
      "termCount": 869,
      "coverage": 0.7272
    },
    {
      "code": "xh",
      "englishName": "Xhosa",
      "nativeName": "isiXhosa",
      "direction": "ltr",
      "font": "Fredoka-Bold.ttf",
      "tier": 4,
      "order": 17,
      "termCount": 869,
      "coverage": 0.7272
    },
    {
      "code": "ne",
      "englishName": "Nepali",
      "nativeName": "नेपाली",
      "direction": "ltr",
      "font": "Poppins-Black.ttf",
      "tier": 4,
      "order": 18,
      "termCount": 869,
      "coverage": 0.7272
    },
    {
      "code": "ps",
      "englishName": "Pashto",
      "nativeName": "پښتو",
      "direction": "rtl",
      "font": "noto_sans_arabic_bold.ttf",
      "tier": 4,
      "order": 19,
      "termCount": 869,
      "coverage": 0.7272
    },
    {
      "code": "ku",
      "englishName": "Kurdish (Kurmanji)",
      "nativeName": "Kurdî (Kurmancî)",
      "direction": "ltr",
      "font": "Fredoka-Bold.ttf",
      "tier": 4,
      "order": 20,
      "termCount": 869,
      "coverage": 0.7272
    },
    {
      "code": "ckb",
      "englishName": "Kurdish (Sorani)",
      "nativeName": "کوردی (سۆرانی)",
      "direction": "rtl",
      "font": "noto_sans_arabic_bold.ttf",
      "tier": 4,
      "order": 21,
      "termCount": 869,
      "coverage": 0.7272
    },
    {
      "code": "ky",
      "englishName": "Kyrgyz",
      "nativeName": "Кыргызча",
      "direction": "ltr",
      "font": "Fredoka-Bold.ttf",
      "tier": 4,
      "order": 22,
      "termCount": 869,
      "coverage": 0.7272
    },
    {
      "code": "mn",
      "englishName": "Mongolian",
      "nativeName": "Монгол",
      "direction": "ltr",
      "font": "Fredoka-Bold.ttf",
      "tier": 4,
      "order": 23,
      "termCount": 869,
      "coverage": 0.7272
    },
    {
      "code": "tg",
      "englishName": "Tajik",
      "nativeName": "тоҷикӣ",
      "direction": "ltr",
      "font": "Fredoka-Bold.ttf",
      "tier": 4,
      "order": 24,
      "termCount": 869,
      "coverage": 0.7272
    },
    {
      "code": "tk",
      "englishName": "Turkmen",
      "nativeName": "Türkmenler",
      "direction": "ltr",
      "font": "Fredoka-Bold.ttf",
      "tier": 4,
      "order": 25,
      "termCount": 869,
      "coverage": 0.7272
    },
    {
      "code": "ug",
      "englishName": "Uyghur",
      "nativeName": "ئۇيغۇر",
      "direction": "rtl",
      "font": "noto_sans_arabic_bold.ttf",
      "tier": 4,
      "order": 26,
      "termCount": 869,
      "coverage": 0.7272
    },
    {
      "code": "be",
      "englishName": "Belarusian",
      "nativeName": "беларускі",
      "direction": "ltr",
      "font": "Fredoka-Bold.ttf",
      "tier": 4,
      "order": 27,
      "termCount": 869,
      "coverage": 0.7272
    },
    {
      "code": "yo",
      "englishName": "Yoruba",
      "nativeName": "Yoruba",
      "direction": "ltr",
      "font": "Fredoka-Bold.ttf",
      "tier": 4,
      "order": 28,
      "termCount": 869,
      "coverage": 0.7272
    },
    {
      "code": "bs",
      "englishName": "Bosnian",
      "nativeName": "bosanski",
      "direction": "ltr",
      "font": "Fredoka-Bold.ttf",
      "tier": 4,
      "order": 29,
      "termCount": 869,
      "coverage": 0.7272
    },
    {
      "code": "sq",
      "englishName": "Albanian",
      "nativeName": "shqiptare",
      "direction": "ltr",
      "font": "Fredoka-Bold.ttf",
      "tier": 4,
      "order": 30,
      "termCount": 869,
      "coverage": 0.7272
    },
    {
      "code": "mk",
      "englishName": "Macedonian",
      "nativeName": "македонски",
      "direction": "ltr",
      "font": "Fredoka-Bold.ttf",
      "tier": 4,
      "order": 31,
      "termCount": 869,
      "coverage": 0.7272
    },
    {
      "code": "sl",
      "englishName": "Slovenian",
      "nativeName": "Slovenščina",
      "direction": "ltr",
      "font": "Fredoka-Bold.ttf",
      "tier": 4,
      "order": 32,
      "termCount": 869,
      "coverage": 0.7272
    },
    {
      "code": "lv",
      "englishName": "Latvian",
      "nativeName": "latviski",
      "direction": "ltr",
      "font": "Fredoka-Bold.ttf",
      "tier": 4,
      "order": 33,
      "termCount": 869,
      "coverage": 0.7272
    },
    {
      "code": "su",
      "englishName": "Sundanese",
      "nativeName": "basa Sunda",
      "direction": "ltr",
      "font": "Fredoka-Bold.ttf",
      "tier": 4,
      "order": 34,
      "termCount": 869,
      "coverage": 0.7272
    },
    {
      "code": "ln",
      "englishName": "Lingala",
      "nativeName": "Lingala",
      "direction": "ltr",
      "font": "Fredoka-Bold.ttf",
      "tier": 4,
      "order": 35,
      "termCount": 869,
      "coverage": 0.7272
    },
    {
      "code": "om",
      "englishName": "Oromo",
      "nativeName": "Afaan Oromoo",
      "direction": "ltr",
      "font": "Fredoka-Bold.ttf",
      "tier": 4,
      "order": 36,
      "termCount": 869,
      "coverage": 0.7272
    },
    {
      "code": "lg",
      "englishName": "Ganda",
      "nativeName": "Ganda",
      "direction": "ltr",
      "font": "Fredoka-Bold.ttf",
      "tier": 4,
      "order": 37,
      "termCount": 869,
      "coverage": 0.7272
    },
    {
      "code": "ny",
      "englishName": "Chichewa",
      "nativeName": "Chichewa",
      "direction": "ltr",
      "font": "Fredoka-Bold.ttf",
      "tier": 4,
      "order": 38,
      "termCount": 869,
      "coverage": 0.7272
    },
    {
      "code": "sn",
      "englishName": "Shona",
      "nativeName": "Shona",
      "direction": "ltr",
      "font": "Fredoka-Bold.ttf",
      "tier": 4,
      "order": 39,
      "termCount": 869,
      "coverage": 0.7272
    },
    {
      "code": "eu",
      "englishName": "Basque",
      "nativeName": "euskara",
      "direction": "ltr",
      "font": "Fredoka-Bold.ttf",
      "tier": 5,
      "order": 1,
      "termCount": 869,
      "coverage": 0.7272
    },
    {
      "code": "ca",
      "englishName": "Catalan",
      "nativeName": "català",
      "direction": "ltr",
      "font": "Fredoka-Bold.ttf",
      "tier": 5,
      "order": 2,
      "termCount": 869,
      "coverage": 0.7272
    },
    {
      "code": "lb",
      "englishName": "Luxembourgish",
      "nativeName": "lëtzebuergesch",
      "direction": "ltr",
      "font": "Fredoka-Bold.ttf",
      "tier": 5,
      "order": 3,
      "termCount": 869,
      "coverage": 0.7272
    },
    {
      "code": "gl",
      "englishName": "Galician",
      "nativeName": "galego",
      "direction": "ltr",
      "font": "Fredoka-Bold.ttf",
      "tier": 5,
      "order": 4,
      "termCount": 869,
      "coverage": 0.7272
    },
    {
      "code": "co",
      "englishName": "Corsican",
      "nativeName": "Corsu",
      "direction": "ltr",
      "font": "Fredoka-Bold.ttf",
      "tier": 5,
      "order": 5,
      "termCount": 869,
      "coverage": 0.7272
    },
    {
      "code": "fy",
      "englishName": "Frisian",
      "nativeName": "Frysk",
      "direction": "ltr",
      "font": "Fredoka-Bold.ttf",
      "tier": 5,
      "order": 6,
      "termCount": 869,
      "coverage": 0.7272
    },
    {
      "code": "ga",
      "englishName": "Irish",
      "nativeName": "Gaeilge",
      "direction": "ltr",
      "font": "Fredoka-Bold.ttf",
      "tier": 5,
      "order": 7,
      "termCount": 869,
      "coverage": 0.7272
    },
    {
      "code": "mt",
      "englishName": "Maltese",
      "nativeName": "Malti",
      "direction": "ltr",
      "font": "Fredoka-Bold.ttf",
      "tier": 5,
      "order": 8,
      "termCount": 869,
      "coverage": 0.7272
    },
    {
      "code": "gd",
      "englishName": "Scots Gaelic",
      "nativeName": "Gàidhlig na h-Alba",
      "direction": "ltr",
      "font": "Fredoka-Bold.ttf",
      "tier": 5,
      "order": 9,
      "termCount": 869,
      "coverage": 0.7272
    },
    {
      "code": "cy",
      "englishName": "Welsh",
      "nativeName": "Cymraeg",
      "direction": "ltr",
      "font": "Fredoka-Bold.ttf",
      "tier": 5,
      "order": 10,
      "termCount": 869,
      "coverage": 0.7272
    },
    {
      "code": "ak",
      "englishName": "Akan",
      "nativeName": "Akan",
      "direction": "ltr",
      "font": "Fredoka-Bold.ttf",
      "tier": 5,
      "order": 11,
      "termCount": 869,
      "coverage": 0.7272
    },
    {
      "code": "ceb",
      "englishName": "Cebuano",
      "nativeName": "Cebuano",
      "direction": "ltr",
      "font": "Fredoka-Bold.ttf",
      "tier": 5,
      "order": 12,
      "termCount": 869,
      "coverage": 0.7272
    },
    {
      "code": "ht",
      "englishName": "Haitian Creole",
      "nativeName": "Kreyòl ayisyen",
      "direction": "ltr",
      "font": "Fredoka-Bold.ttf",
      "tier": 5,
      "order": 13,
      "termCount": 869,
      "coverage": 0.7272
    },
    {
      "code": "hmn",
      "englishName": "Hmong",
      "nativeName": "Hmoob",
      "direction": "ltr",
      "font": "Fredoka-Bold.ttf",
      "tier": 5,
      "order": 14,
      "termCount": 869,
      "coverage": 0.7272
    },
    {
      "code": "ilo",
      "englishName": "Iloko",
      "nativeName": "Iloko",
      "direction": "ltr",
      "font": "Fredoka-Bold.ttf",
      "tier": 5,
      "order": 15,
      "termCount": 869,
      "coverage": 0.7272
    },
    {
      "code": "kri",
      "englishName": "Krio",
      "nativeName": "Krio",
      "direction": "ltr",
      "font": "Fredoka-Bold.ttf",
      "tier": 5,
      "order": 16,
      "termCount": 869,
      "coverage": 0.7272
    },
    {
      "code": "mg",
      "englishName": "Malagasy",
      "nativeName": "Malagasy",
      "direction": "ltr",
      "font": "Fredoka-Bold.ttf",
      "tier": 5,
      "order": 17,
      "termCount": 869,
      "coverage": 0.7272
    },
    {
      "code": "lus",
      "englishName": "Mizo",
      "nativeName": "Mizo tawng",
      "direction": "ltr",
      "font": "Fredoka-Bold.ttf",
      "tier": 5,
      "order": 18,
      "termCount": 869,
      "coverage": 0.7272
    },
    {
      "code": "nso",
      "englishName": "Northern Sotho",
      "nativeName": "Sesotho sa Leboa",
      "direction": "ltr",
      "font": "Fredoka-Bold.ttf",
      "tier": 5,
      "order": 19,
      "termCount": 869,
      "coverage": 0.7272
    },
    {
      "code": "rw",
      "englishName": "Kinyarwanda",
      "nativeName": "Kinyarwanda",
      "direction": "ltr",
      "font": "Fredoka-Bold.ttf",
      "tier": 5,
      "order": 20,
      "termCount": 869,
      "coverage": 0.7272
    },
    {
      "code": "so",
      "englishName": "Somali",
      "nativeName": "Soomaali",
      "direction": "ltr",
      "font": "Fredoka-Bold.ttf",
      "tier": 5,
      "order": 21,
      "termCount": 869,
      "coverage": 0.7272
    },
    {
      "code": "sm",
      "englishName": "Samoan",
      "nativeName": "Samoa",
      "direction": "ltr",
      "font": "Fredoka-Bold.ttf",
      "tier": 5,
      "order": 22,
      "termCount": 869,
      "coverage": 0.7272
    },
    {
      "code": "tt",
      "englishName": "Tatar",
      "nativeName": "Татар",
      "direction": "ltr",
      "font": "Fredoka-Bold.ttf",
      "tier": 5,
      "order": 23,
      "termCount": 869,
      "coverage": 0.7272
    },
    {
      "code": "gn",
      "englishName": "Guarani",
      "nativeName": "guarani",
      "direction": "ltr",
      "font": "Fredoka-Bold.ttf",
      "tier": 5,
      "order": 24,
      "termCount": 869,
      "coverage": 0.7272
    },
    {
      "code": "qu",
      "englishName": "Quechua",
      "nativeName": "Runasimi",
      "direction": "ltr",
      "font": "Fredoka-Bold.ttf",
      "tier": 5,
      "order": 25,
      "termCount": 869,
      "coverage": 0.7272
    }
  ]
}
